import React from 'react';
import TeamMember from '../../components/Team/TeamMember';
import TeamImg1 from '../../assets/images/team/team-1-1.jpg';
import TeamImg2 from '../../assets/images/team/team-1-2.jpg';
import TeamImg3 from '../../assets/images/team/team-1-3.jpg';
import TeamImg4 from '../../assets/images/team/team-1-4.jpg';



const TeamMain = () => {
    // Example team member data
    const teamMemberData = [
        {
          id: 1,
          image: TeamImg1,
          name: 'Brooklyn Simmons',
          position: 'Roof Renewal Expert',
          description: 'Roof service involves the installation, maintenance, and repair of roofs for residential and commercial properties.',
          link: '/team-details',
          socialLinks: [
            { url: '#', iconClass: 'icon-instagram' },
            { url: '#', iconClass: 'icon-linkedin-in' },
            { url: '#', iconClass: 'icon-Vector' },
            { url: '#', iconClass: 'icon-facebook-f' },
          ],
        },
        {
          id: 2,
          image: TeamImg2,
          name: 'Warner David',
          position: 'Roof Pros',
          description: 'Roof service involves the installation, maintenance, and repair of roofs for residential and commercial properties.',
          link: '/team-details',
          socialLinks: [
            { url: '#', iconClass: 'icon-instagram' },
            { url: '#', iconClass: 'icon-linkedin-in' },
            { url: '#', iconClass: 'icon-Vector' },
            { url: '#', iconClass: 'icon-facebook-f' },
          ],
        },
        {
          id: 3,
          image: TeamImg3,
          name: 'Shaib Khan',
          position: 'Roofing Service Man',
          description: 'Roof service involves the installation, maintenance, and repair of roofs for residential and commercial properties.',
          link: '/team-details',
          socialLinks: [
            { url: '#', iconClass: 'icon-instagram' },
            { url: '#', iconClass: 'icon-linkedin-in' },
            { url: '#', iconClass: 'icon-Vector' },
            { url: '#', iconClass: 'icon-facebook-f' },
          ],
        },
        {
          id: 4,
          image: TeamImg4,
          name: 'David Hais',
          position: 'Roof Master',
          description: 'Roof service involves the installation, maintenance, and repair of roofs for residential and commercial properties.',
          link: '/team-details',
          socialLinks: [
            { url: '#', iconClass: 'icon-instagram' },
            { url: '#', iconClass: 'icon-linkedin-in' },
            { url: '#', iconClass: 'icon-Vector' },
            { url: '#', iconClass: 'icon-facebook-f' },
          ],
        },
        // You can add more team members here
      ];
    

    return (
        <React.Fragment>
            {/* Team One Start */}
            <section className="team-one">
                <div className="container">
                <div className="row">
                    {teamMemberData.map(member => (
                    <div key={member.id} className="col-xl-6 col-lg-6">
                        <TeamMember {...member} />
                    </div>
                    ))}
                </div>
                </div>
            </section>
            {/* Team One End */}
        </React.Fragment>
    );
};

export default TeamMain;
